import * as React from "react";
import { Icon } from "../actions/Icon";

/**
 * Rounded-square checkbox used for action items.
 */
export interface CheckboxProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "onChange"> {
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (checked: boolean) => void;
  size?: "sm" | "md";
  label?: string;
}

export function Checkbox({
  checked,
  defaultChecked = false,
  onChange,
  size = "md",
  label,
  className,
  ...rest
}: CheckboxProps): JSX.Element {
  const [inner, setInner] = React.useState(defaultChecked);
  const on = checked === undefined ? inner : checked;
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={on}
      aria-label={label}
      className={["gk-check", size === "sm" && "gk-check--sm", className].filter(Boolean).join(" ")}
      onClick={() => {
        if (checked === undefined) setInner(!on);
        onChange?.(!on);
      }}
      {...rest}
    >
      {on && <Icon name="check" size={14} style={{ fontVariationSettings: "'wght' 600" }} />}
    </button>
  );
}
